export enum BinanceAssetMainnetShortcode {
  CardanoBscToken = 'ADA_BEP20',
  EOSBscToken = 'EOS_BEP20',
  TronBscToken = 'TRX_BEP20',
  WavesBscToken = 'WAVES_BEP20',
  RippleBscToken = 'XRP_BEP20',
  WLunaBscToken = 'WLUNA_BEP20',
  DogecoinBscToken = 'DOGE_BEP20',
  NanomaticBscToken = 'NANO_BEP20',
  ZcashBscToken = 'ZEC_BEP20',
  CosmosBscToken = 'ATOM_BEP20',
  LiskBscToken = 'LSK_BEP20',
  FilecoinBscToken = 'FIL_BEP20',
  AirCoinBscToken = 'AIR_BEP20',
  AlphaVentureDAOBscToken = 'ALPHA_BEP20',
  MultiversXBscToken = 'EGLD_BEP20',
  STEPNBscToken = 'GMT_BEP20',
  Keep3rBSCNetworkBscToken = 'KP3R_BEP20',
  NEARProtocolBscToken = 'NEAR_BEP20',
  THORChainBscToken = 'RUNE_BEP20',
  StepBscToken = 'STEP_BEP20',
  UnifiProtocolDAOBscToken = 'UNFI_BEP20',
  SafeMoonBscToken = 'SAFEMOON_BEP20',
  GameXBscToken = 'EXP_BEP20',
  TrustWalletBscToken = 'TWT_BEP20',
  VenusBNBBscToken = 'vBNB_BEP20',
  PancakeSwapBscToken = 'CAKE_BEP20',
  ZilliqaBscToken = 'ZIL_BEP20',
  FIFAWorldCupFansBscToken = 'FIFA_BEP20',
  Web3InuBscToken = 'WEB3_BEP20',
  BinanceUSDBscToken = 'BUSD_BEP20',
  EthereumBscToken = 'ETH_BEP20',
}

export enum BinanceAssetTestnetShortcode {
  ZetaBscTokenTest = 'ZETA_BEP20_TEST'
}

export const BinanceAssetShortcode = Object.assign({}, BinanceAssetMainnetShortcode, BinanceAssetTestnetShortcode);
export type BinanceAssetShortcode = BinanceAssetMainnetShortcode | BinanceAssetTestnetShortcode;

export const BINANCE_TOKENS = new Set(Object.values(BinanceAssetShortcode));
